import { useTranslation } from 'react-i18next';
import { Switch } from '@shared/components/ui/shadcn/switch';
import { useId } from 'react';
import type { NotificationReadFilter } from '../../models/Notification.types';

interface NotificationFiltersProps {
  readFilter: NotificationReadFilter;
  onReadFilterChange: (filter: NotificationReadFilter) => void;
}

export const NotificationFilters = ({ readFilter, onReadFilterChange }: NotificationFiltersProps) => {
  const { t } = useTranslation('notificationsModule');
  const labelId = useId();
  const showRead = readFilter === 'read';

  return (
    <div className="flex items-center justify-between gap-3">
      <span id={labelId} className="text-subtext text-xs font-medium leading-4 shrink-0">
        {t('notifications.filter.label')}
      </span>
      <div className="flex items-center gap-2 min-w-0 flex-1 justify-end">
        <span className={`text-xs font-medium truncate transition-colors ${!showRead ? 'text-text' : 'text-subtext'}`}>
          {t('notifications.filter.unread')}
        </span>
        <Switch
          checked={showRead}
          onCheckedChange={(checked) => onReadFilterChange(checked ? 'read' : 'unread')}
          aria-labelledby={labelId}
          data-testid="notification-read-filter-switch"
        />
        <span className={`text-xs font-medium truncate transition-colors ${showRead ? 'text-text' : 'text-subtext'}`}>
          {t('notifications.filter.read')}
        </span>
      </div>
    </div>
  );
};
